var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1417_3165",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1417_3165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.30769 16.822H18.4423V16.4214C18.4423 15.6554 18.0257 15.043 17.1927 14.5841C16.3596 14.1252 15.2537 13.8958 13.875 13.8958C12.4962 13.8958 11.3903 14.1252 10.5573 14.5841C9.72422 15.043 9.30769 15.6554 9.30769 16.4214V16.822ZM13.875 11.8637C14.4533 11.8637 14.947 11.6592 15.356 11.2502C15.765 10.8412 15.9695 10.3475 15.9695 9.76919C15.9695 9.19086 15.765 8.69719 15.356 8.28819C14.947 7.87917 14.4533 7.67466 13.875 7.67466C13.2966 7.67466 12.803 7.87917 12.394 8.28819C11.9849 8.69719 11.7804 9.19086 11.7804 9.76919C11.7804 10.3475 11.9849 10.8412 12.394 11.2502C12.803 11.6592 13.2966 11.8637 13.875 11.8637ZM2 26.173V4.95513C2 4.41788 2.19154 3.95771 2.57463 3.57463C2.95771 3.19154 3.41788 3 3.95513 3H23.7948C24.3321 3 24.7922 3.19154 25.1753 3.57463C25.5584 3.95771 25.7499 4.41788 25.7499 4.95513V19.7948C25.7499 20.3321 25.5584 20.7922 25.1753 21.1753C24.7922 21.5584 24.3321 21.7499 23.7948 21.7499H6.42306L2 26.173ZM5.74359 20.1795H23.7948C23.891 20.1795 23.9791 20.1394 24.0592 20.0592C24.1394 19.9791 24.1795 19.891 24.1795 19.7948V4.95513C24.1795 4.85896 24.1394 4.77081 24.0592 4.69069C23.9791 4.61054 23.891 4.57047 23.7948 4.57047H3.95513C3.85896 4.57047 3.77081 4.61054 3.69069 4.69069C3.61054 4.77081 3.57047 4.85896 3.57047 4.95513V22.4391L5.74359 20.1795Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRequest);
export default __webpack_public_path__ + "static/media/user_request.acc2a366e6b7f87098dce6d8c84385f8.svg";
export { ForwardRef as ReactComponent };